/**
 * Tank specific function for getting a generated image url based on size preset and extension
 * @param  {Object} file 			- Image object, containing keys: filename,
 * @param  {String} size 			- Image size preset - defined in tank, defaults to 'cockpit-small'
 * @param  {String} extension 		- Not required, used to specify extension, defaults to original file extension
 * @param  {Boolean} getOriginal 	- Whether or not to fetch pre-edited image
 * @return {String} 				- Returns url string
 */
export function getImageUrl(file, size = 'cockpit-small', extension = null, getOriginal = false) {
  if (typeof file != 'object' || file instanceof Array || !file.filename || typeof size != 'string') return false
  const dot = file.filename.lastIndexOf('.')
  if (!file.slug) file.slug = file.filename.substr(0, dot)
  if (!file.extension) file.extension = file.filename.substr(dot + 1, file.filename.length)
  if (file.extension == 'svg') return getFileUrl(file)
  const originalStr = getOriginal ? 'original/' : ''
  let url =
    '/generated/' +
    originalStr +
    size +
    '/' +
    file.slug +
    '.' +
    (extension ? extension : file.extension ? file.extension : 'jpg')

  if (window.CDN_PREFIX) url = window.CDN_PREFIX + url
  // else if (window.location.href.indexOf('bsapi') >= 0) url = 'https://2017.bigsound.org.au' + url

  return url
}

export function getFileUrl(file) {
  if (typeof file != 'object' || file instanceof Array || !file.filename) return false
  let url = `/uploads/${file.filename}`
  if (window.CDN_PREFIX) url = window.CDN_PREFIX + url
  return url
}
